import { useEffect, useState } from "react";
import axios from "axios";
import { Target } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const p = (v) => (v == null ? "—" : `${(v * 100).toFixed(1)}%`);

export const SignalTrackCard = ({ tick }) => {
  const [t, setT] = useState(null);
  useEffect(() => {
    axios.get(`${API}/signals/track`).then((r) => setT(r.data)).catch(() => {});
  }, [tick]);
  if (!t) return null;
  return (
    <section className="card p-5 sm:p-6 fade-up" data-testid="signal-track-card">
      <h2 className="font-head font-bold text-lg flex items-center gap-2"><Target className="w-5 h-5 text-[#22D3EE]" /> Signal track record (live)</h2>
      <p className="text-xs text-slate-400 mt-1">
        Every time all signal criteria except validation are met, the app logs a candidate (first one per window) and scores it at settlement
        as a hypothetical $1 at the logged ask incl. fees. UP/DOWN alerts unlock only after {t.min_n}+ scored signals with a 95% return interval above 0.
      </p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-3 font-num text-sm">
        <div className="rounded-lg border border-[#1A2338] bg-[#0F1A2E] p-3" data-testid="track-n">Scored <b className="block text-lg">{t.n}</b><span className="text-[11px] text-slate-500">{t.pending || 0} pending</span></div>
        <div className="rounded-lg border border-[#1A2338] bg-[#0F1A2E] p-3" data-testid="track-winrate">Win rate <b className="block text-lg">{p(t.win_rate)}</b>
          <span className="text-[11px] text-slate-500">{t.win_rate_ci ? `95% ${p(t.win_rate_ci[0])}–${p(t.win_rate_ci[1])}` : ""}</span></div>
        <div className="rounded-lg border border-[#1A2338] bg-[#0F1A2E] p-3" data-testid="track-breakeven">Breakeven win rate <b className="block text-lg">{p(t.avg_breakeven_price)}</b>
          <span className="text-[11px] text-slate-500">avg price paid incl. fee</span></div>
        <div className="rounded-lg border border-[#1A2338] bg-[#0F1A2E] p-3" data-testid="track-return">Avg return / $1 <b className="block text-lg">{p(t.avg_return)}</b>
          <span className="text-[11px] text-slate-500">{t.avg_return_ci ? `95% ${p(t.avg_return_ci[0])} to ${p(t.avg_return_ci[1])}` : ""}</span></div>
      </div>
      <div className={`mt-3 rounded-lg p-3 text-sm ${t.validated ? "bg-emerald-500/10 text-emerald-200" : "bg-amber-500/10 text-amber-200"}`} data-testid="track-verdict">
        {t.validated ? "Track record validated — UP/DOWN alerts are enabled (still not a guarantee)." :
          `Not validated yet (${t.n}/${t.min_n} scored). Alerts stay on WAIT; candidates are only logged.`}
      </div>
      <div className="mt-3 space-y-1 text-xs font-num" data-testid="track-recent">
        {(t.recent || []).map((r) => (
          <div key={r.window_ts} className="flex justify-between border-b border-[#1A2338] py-1">
            <span>{new Date(r.window_ts * 1000).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })} · {r.side} @ {Math.round(r.ask * 100)}¢ · model {p(r.model)} / mkt {p(r.market)}</span>
            <span className={r.won ? "text-[#34D399]" : r.won === false ? "text-[#F87171]" : "text-slate-500"}>{r.won == null ? "pending" : r.won ? `won ${p(r.ret)}` : "lost"}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
